import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Phone, MapPin, Send, Loader2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export function Footer() {
  const [email, setEmail] = useState("");
  const [subLoading, setSubLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setSubLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      if (data.already) toast.info(data.message);
      else toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSubLoading(false);
    }
  };

  return (
    <footer style={{ background: "var(--ink)", color: "var(--bone)" }} data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center mb-5">
              <img src="/aldol-logo.png" alt="ALDOL-SOLUTIONS" className="h-28 w-28 object-contain rounded" style={{ background: "var(--bone)" }} />
            </div>
            <p className="text-lg max-w-sm" style={{ color: "rgba(245,245,240,0.65)" }}>
              Matériel ergonomique, équipements de protection, conseil QSE et formations certifiantes pour les entreprises exigeantes.
            </p>
            <div className="mt-8">
              <p className="overline mb-3" style={{ color: "var(--orange)" }}>Newsletter Conseils</p>
              <p className="text-sm mb-4" style={{ color: "rgba(245,245,240,0.65)" }}>Recevez nos nouveaux articles ergonomie, sécurité et QVT par email.</p>
              <form onSubmit={subscribe} className="flex gap-2 max-w-sm" data-testid="newsletter-form">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Votre email professionnel"
                  className="flex-1 px-4 py-3 text-sm" data-testid="newsletter-email-input"
                  style={{ background: "rgba(245,245,240,0.08)", border: "1px solid rgba(245,245,240,0.2)", color: "var(--bone)", outline: "none" }} />
                <button type="submit" disabled={subLoading} className="btn-primary px-4 py-3" data-testid="newsletter-submit-btn" aria-label="S'abonner">
                  {subLoading ? <Loader2 size={17} className="animate-spin" /> : <Send size={17} />}
                </button>
              </form>
            </div>
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <p className="overline mb-5" style={{ color: "var(--orange)" }}>Navigation</p>
            <ul className="space-y-3">
              {[["Catalogue", "/catalogue"], ["Accompagnement", "/services"], ["Formations", "/formations"], ["Références", "/references"], ["Notre équipe", "/equipe"], ["International", "/international"], ["Inclusion & handicap", "/inclusion-handicap"], ["Conseils", "/conseils"], ["FAQ", "/faq"], ["Contact", "/contact"], ["Espace client", "/espace-client"], ["Suivi devis", "/suivi-devis"], ["Espace admin", "/admin/login"]].map(([l, t]) => (
                <li key={t}><Link to={t} className="link-hover" style={{ color: "rgba(245,245,240,0.8)" }}>{l}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-5" style={{ color: "var(--orange)" }}>Contact</p>
            <ul className="space-y-3" style={{ color: "rgba(245,245,240,0.8)" }}>
              <li data-testid="footer-email"><a href="mailto:contact@aldol-solutions.fr" className="link-hover flex items-center gap-3"><Mail size={16} /> contact@aldol-solutions.fr</a></li>
              <li data-testid="footer-phone"><a href="tel:+33780816014" className="link-hover flex items-center gap-3"><Phone size={16} /> 07 80 81 60 14</a></li>
              <li data-testid="footer-whatsapp"><a href="https://wa.me/33776575461" target="_blank" rel="noopener noreferrer" className="link-hover flex items-center gap-3"><MessageCircle size={16} /> WhatsApp Business : +33 7 76 57 54 61</a></li>
              <li className="flex items-start gap-3" data-testid="footer-address"><MapPin size={16} className="mt-1 shrink-0" /> 15 Avenue de l'Alma, 94210 Saint-Maur-des-Fossés, France</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-sm"
          style={{ borderTop: "1px solid rgba(245,245,240,0.15)", color: "rgba(245,245,240,0.5)" }}>
          <span>© 2026 ALDOL-SOLUTIONS. Tous droits réservés.</span>
          <span className="font-mono2">QSE · ERGONOMIE · EPI · FORMATION</span>
        </div>
      </div>
    </footer>
  );
}
